/* eslint-disable camelcase */
import React, { useState } from 'react'
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import ProfileCard from './ProfileCard'
import { AreaInput, FormKort, FormTitle, InputTxt, InputTxtCon, KontaktFormSection, KontIcon, KontInfo, KontInfoCon, KontRightCon, SubmitBtn } from './KontaktFormular.styled'

const KontaktFormular = () => {
    const [status, setStatus] = useState("Send");
    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sender...");
        const { from_name, from_firm, from_phone, from_mail, message } = e.target.elements;
        const details = {
            from_name: from_name.value,
            from_firm: from_firm.value,
            from_phone: from_phone.value,
            from_mail: from_mail.value,
            message: message.value,
        };
        const response = await fetch("http://localhost:3000/om-os", {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(details),
        });
        setStatus("Send");
        const result = await response.json();
        alert(result.status);
    };
    return (
        <KontaktFormSection>
            <FormKort onSubmit={handleSubmit}>
                <FormTitle>Kontakt formular</FormTitle>
                <InputTxtCon>
                    <InputTxt type="text" name="from_name" id="from_name" required placeholder='Navn*' />
                    <InputTxt type="text" name="from_firm" id="from_firm" placeholder='Firmanavn' />
                    <InputTxt type="tel" name="from_phone" id="from_phone" required placeholder='Tlf. Nr.*' />
                    <InputTxt type="email" name="from_mail" id="from_mail" required placeholder='Mail adresse*' />
                    <AreaInput name="message" id="message" cols="10" rows="10" placeholder='Besked' />
                </InputTxtCon>
                <SubmitBtn type='submit'> {status} </SubmitBtn>
            </FormKort>
            <KontRightCon>
                <h1>
                    Vi glæder os til at hjælpe dig!
                </h1>
                <p>
                    Den loyale, og mest konkurrencedygtige virksomhed som Appbureau der forbedrer dine resultater. <br />
                    Vi ønsker at gøre dit samarbejde med os til din succes. <br /> <br />
                    Få 30 minutters gratis rådgivning af din virksomhed omkring din nuværende situation. <br />
                    Vi analysere din brand identitet online, og giver et overblik over hvor du mangler hjælp.
                </p>
                <KontInfoCon>
                    <div>

                        <KontInfo href='tel:+4520741066'>
                            <KontIcon icon={faPhone} />
                            20 74 10 66
                        </KontInfo>
                        <KontInfo href='mailto:info@noaly.dk'>
                            <KontIcon icon={faEnvelope} />
                            info@noaly.dk
                        </KontInfo>
                        <KontInfo>
                            <KontIcon icon={faLocationDot} />
                            2300 København S
                        </KontInfo>
                    </div>

                    <ProfileCard
                        name='Brian Hansen'
                        title='Full stack udvikler'
                        besked='Skal jeg lave din næste App?'
                    />
                </KontInfoCon>
            </KontRightCon>
        </KontaktFormSection>
    )
}

export default KontaktFormular